export default __webpack_public_path__ + "static/joie@2x-14590f0207f4aecb94ff71062a107b60.jpg";